<template>
  <div id="app">
    <router-view></router-view>
    <toast :text="text" ref="toast" textBgColor="rgba(58,58,58,.9) !important"></toast>
    <full-loading v-show="showFullLoading" :title="fullLoadingText"></full-loading>
    <wxtip :show="showwxtip"></wxtip>
  </div>
</template>

<script>
import toast from '@/common/components/toast/toast';
import fullLoading from '@/common/components/full-loading/full-loading';
import wxtip from '@/components/wxtip';
export default {
  name: 'App',
   provide(){
     return{
      openWxTip: this.openWxTip
     }
   },
  data() {
    return {
      text: '',
      showFullLoading: false,
      toastIsLandscape: false,
      fullLoadingText: '',
      showwxtip: false,
    }
  },
  
  components: {
    wxtip,
    toast,
    fullLoading,
  },
  computed: {

  },
  mounted() {
    console.log('sy-1455');
    this.resize();
    window.addEventListener('resize', this.resize);
    window.showToast = this.showToast
  },
  methods: {
     openWxTip() {
      this.showwxtip = true;
    },
    resize () {
      var width = document.documentElement.clientWidth,
          height = document.documentElement.clientHeight,
          $wrapper = document.getElementById("app"),
          style = "";

      style += "height:" + height + "px;";

      if(width > 527) {
        let appWidth = (320*height)/568
        style += "width:" + appWidth + "px;";
        sessionStorage.setItem('pcPaddingLeft', (width-appWidth)/2)
      } else {
        style += "width:" + width + "px;";
      }
      $wrapper.style.cssText = style;
    },
     /*顶层常用方法*/
     showToast(text, isLandscape=false, hide=true) {
      this.text = text;
      this.toastIsLandscape = isLandscape;
      if(hide) {
        this.$refs.toast.show();
      } else {
        this.$refs.toast.showNoHide();
      }    
    },
  }
}
</script>

<style>
@import './style/common.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
body,html{
  background: #eee;
  height: 100%;
  padding: 0;
  margin: 0;
  touch-action: manipulation;
}

  div, p, h1, h2, h3, h4, h5, h6, ul, li {
      padding: 0;
      margin: 0;
  }

  #app{
    width: 100%;
    height: 100%;
    position: relative;
    transform: translate(0,0);
    margin: 0 auto;
    overflow: hidden;
  }

  * {
    box-sizing: border-box;
    user-select: auto;
    -webkit-overflow-scrolling: touch;
  }
  body{
    background: transparent;
  }
* {
    box-sizing: border-box;
    user-select: auto;
    -webkit-overflow-scrolling: touch;
    text-align: left;
  }
</style>
